<template>
  <div id='axleshuntevents-page'>
    <div class="row no-margin-bottom">
      <div class="col s9">
        <div class="row no-margin-bottom" style="padding: 10px">
          <div class="col s12 z-depth-1 white" style="padding-top: 10px">
            <highcharts :options="chartOptionsEV" ref="chartEv" />
          </div>
        </div>
      </div>
      <div class="col s3">
        <div class="row no-margin-bottom" style="padding: 10px">
          <div class="col s12 z-depth-1 white" style="height: 260px;" margin="auto">
            <div class="row">
              <div class="col s12">
                <button :title="$t('axleshunt.previous')" class="waves-effect waves-light btn buttonbg" @click="prevFrame"><i class="material-icons">keyboard_arrow_left</i></button>
                <date-picker @input="dateChanged" v-model="date" :max-date="maxDate" @dateChanged="datePickerChanged" style="padding-top: 10px; padding-right: 6px; display: inline-block" />
                <button :title="$t('axleshunt.next')" class="waves-effect waves-light btn buttonbg" @click="nextFrame" :disabled="nextDisabled"><i class="material-icons">keyboard_arrow_right</i></button>
                <button :title="$t('axleshunt.last')" class="waves-effect waves-light btn buttonbg" @click="lastFrame"><i class="material-icons">keyboard_tab</i></button>
                <button :title="$t('axleshunt.refresh')" class="waves-effect waves-light btn buttonbg" @click="load"><i class="material-icons">refresh</i></button>
              </div>
            </div>
            <div class="row">
              <div class="col s12">
                <period-selector v-model="selectedPeriod" />
              </div>
            </div>
            <div class="row">
              <div class="col s5" style="padding-top: 10px">
                <a v-show="selectedPoints.length > 1" @click="clearSelected" class="actionLink">
                  {{ $t('events.clearSelected') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="padding: 10px; padding-bottom:0px">
      <div class="col s12 z-depth-1 white">
         <div id="chart" class="row" style="padding: 10px">
            <highcharts :options="chartOptions" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <div class="z-depth-1 white" style="padding: 10px">
          <table>
            <tr v-for="(item,index) in shuntMessagesPresented" :key="index">
              <td class="listViewcell" >
                  <span style="padding:0px;margin:0px;height:10px">
                  <i  class="material-icons small" :style="{color: shuntColorPresented[index]}">remove</i>
                  </span>
              </td>
              <td class="listViewcell">
                  <span>
                    <i> {{shuntDateTimePresented[index]}}</i>
                  </span>
              </td>
              <td class="listViewcell">
                  <span>
                    <i>{{ shuntSeverityPresented[index]}}</i>
                  </span>
              </td>
              <td class="listViewcell">
                <span class="body1">{{item}}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubMenu from '@/components/SubMenu'
import SectionOccupationsService from '@/services/api/axleshunt/SectionOccupationsService'
import SectionAlarmService from '@/services/r8/SectionAlarmService'
import M from 'materialize-css'
import Highcharts from 'highcharts'
import rca from 'rainbow-colors-array'
import DatePicker from '@/components/switch/DatePicker'
import moment from 'moment'
import PeriodSelector from '@/components/PeriodSelector'

const colors = {
  ok: 'black',
  warning: 'orange',
  alarm: 'red',
  offset: 'grey'
}

const maxSelectedPoints = 5
const chartOptionsEv = function (t) {
  return {
    chart: {
      height: 250,
      zoomType: 'x',
      resetZoomButton: {
        position: {
          x: 0,
          y: -10
        }
      },
      animation: false,
      zooming: {
        mouseWheel: {
          enabled: true
        }
      },
      events: {
        load () {
          const chart = this

          // Block scroll wheel unless Shift is held
          chart._wheelBlocker = (e) => {
            if (!e.shiftKey) {
              if (e.stopImmediatePropagation) e.stopImmediatePropagation()
              e.stopPropagation()
            }
          }
          chart.container.addEventListener('wheel', chart._wheelBlocker, { capture: true })

          // Show zoom cursor when Shift is held
          chart._cursorHint = (e) => {
            chart.container.style.cursor = e.shiftKey ? 'zoom-in' : ''
          }
          chart.container.addEventListener('mousemove', chart._cursorHint)

          // Flip cursor immediately on Shift press/release
          chart._onKeyShift = (e) => {
            if (e.key === 'Shift' && chart.container) {
              chart.container.style.cursor = (e.type === 'keydown') ? 'zoom-in' : ''
            }
          }
          chart._offKeyDown = Highcharts.addEvent(document, 'keydown', chart._onKeyShift)
          chart._offKeyUp = Highcharts.addEvent(document, 'keyup', chart._onKeyShift)
        },
        destroy () {
          const el = this.container
          if (this._wheelBlocker && el) el.removeEventListener('wheel', this._wheelBlocker, { capture: true })
          if (this._cursorHint && el) el.removeEventListener('mousemove', this._cursorHint)
          if (this._offKeyDown) this._offKeyDown()
          if (this._offKeyUp) this._offKeyUp()
        }
      }
    },
    plotOptions: {
      series: {
        allowPointSelect: true
      }
    },
    time: {
      useUTC: false
    },
    exporting: {
      enabled: false
    },
    accessibility: {
      enabled: false
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    subtitle: {
      text: ''
    },
    legend: {
      enabled: true
    },
    tooltip: {
      formatter: function () {
        let utcTimew = moment.utc(this.x)
        let localTimew = utcTimew.local()
        return moment(localTimew).format('YYYY-MM-DD HH:mm:ss')
      },
      shared: true
    },
    xAxis: {
      title: {
        enabled: false
      },
      type: 'datetime',
      gridLineWidth: 1,
      dateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%e %b \'%y',
        week: '%e %b \'%y',
        month: '%b \'%y',
        year: '%Y'
      }
    },
    yAxis: [
      {
        visible: false
      }
    ],
    series: [
      {
        name: 'Normal',
        type: 'scatter',
        marker: {
          symbol: 'diamond',
          radius: 3,
          fillColor: colors.ok
        },
        zIndex: 3,
        data: [],
        turboThreshold: 10000,
        yAxis: 0,
        stickyTracking: false,
        point: {
          events: {
            click: (e) => {
              if (t.switchSelected(e.point.id)) { t.refresh() }
              return false
            }
          }
        }
      },
      {
        name: 'Warning',
        type: 'scatter',
        marker: {
          symbol: 'circle',
          radius: 8,
          fillColor: colors.warning
        },
        zIndex: 1,
        data: [],
        turboThreshold: 10000,
        yAxis: 0,
        stickyTracking: false,
        point: {
          events: {
            click: (e) => {
              if (t.switchSelected(e.point.id)) { t.refresh() }
              return false
            }
          }
        }
      },
      {
        name: 'Alarm',
        type: 'scatter',
        marker: {
          symbol: 'triangle',
          radius: 8,
          fillColor: colors.alarm
        },
        zIndex: 2,
        data: [],
        turboThreshold: 10000,
        yAxis: 0,
        stickyTracking: false,
        point: {
          events: {
            click: (e) => {
              if (t.switchSelected(e.point.id)) { t.refresh() }
              return false
            }
          }
        }
      }
    ]
  }
}

const chartOptions = function (vm) {
  return {
    chart: {
      zoomType: '',
      animation: false,
      zooming: {
        mouseWheel: {
          enabled: true
        }
      },
      events: {
        load () {
          const chart = this

          // Block scroll wheel unless Shift is held
          chart._wheelBlocker = (e) => {
            if (!e.shiftKey) {
              if (e.stopImmediatePropagation) e.stopImmediatePropagation()
              e.stopPropagation()
            }
          }
          chart.container.addEventListener('wheel', chart._wheelBlocker, { capture: true })

          // Show zoom cursor when Shift is held
          chart._cursorHint = (e) => {
            chart.container.style.cursor = e.shiftKey ? 'zoom-in' : ''
          }
          chart.container.addEventListener('mousemove', chart._cursorHint)

          // Flip cursor immediately on Shift press/release
          chart._onKeyShift = (e) => {
            if (e.key === 'Shift' && chart.container) {
              chart.container.style.cursor = (e.type === 'keydown') ? 'zoom-in' : ''
            }
          }
          chart._offKeyDown = Highcharts.addEvent(document, 'keydown', chart._onKeyShift)
          chart._offKeyUp = Highcharts.addEvent(document, 'keyup', chart._onKeyShift)
        },
        destroy () {
          const el = this.container
          if (this._wheelBlocker && el) el.removeEventListener('wheel', this._wheelBlocker, { capture: true })
          if (this._cursorHint && el) el.removeEventListener('mousemove', this._cursorHint)
          if (this._offKeyDown) this._offKeyDown()
          if (this._offKeyUp) this._offKeyUp()
        }
      }
    },
    plotOptions: {
      series: {
        stickyTracking: false,
        marker: false,
        turboThreshold: 0
      }
    },
    exporting: {
      enabled: true
    },
    accessibility: {
      enabled: false
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    subtitle: {
      text: ''
    },
    legend: {
      enabled: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      useHTML: true,
      formatter () {
        let s = '<b>Time: ' + this.x.toFixed(2) + 's </b><br>'
        if (this.points) {
          const validPoints = this.points.filter(point =>
              point.series.name !== 'warning' &&
              point.series.name !== 'alarm' &&
              point.series.name !== 'offset'
            )
          if (validPoints.length === 0 || this.x === 0) {
            return false
          }
          validPoints.forEach(point => {
            if (point.series.name !== 'warning' &&
            point.series.name !== 'alarm' &&
            point.series.name !== 'offset') {
              s += `<span style='color:${point.series.color};font-weight:bold;'>&#9679;</span> `
              s += `<span style='color:${point.series.color}'>${point.series.name}</span>: <b>${point.y}</b><br/>`
            }
          })
        } else if (this.point) {
          alert('hans')
          // fallback for non-shared tooltips
          if (this.point.series.name !== 'warning' &&
          this.point.series.name !== 'alarm' &&
          this.point.series.name !== 'offset') {
            s += `<span style='color:${this.point.series.color};font-weight:bold;'>&#9679;</span> `
            s += `<span style='color:${this.point.series.color}'>${this.point.series.name}</span>: <b>${this.point.y}</b><br/>`
          }
        }
        return s
      }
    },
    xAxis: {
      title: {
        text: 'Time (s)'
      },
      type: 'time'
    },
    yAxis: {
      title: {
        text: 'mA'
      }
    },
    series: [
      { id: 'warning', name: 'warning', data: [], color: colors.warning, zIndex: 100, lineWidth: 1 },
      { id: 'alarm', name: 'alarm', data: [], color: colors.alarm, zIndex: 100, lineWidth: 1 },
      { id: 'offset', name: 'offset', data: [], color: colors.offset, zIndex: 100, lineWidth: 1 }
    ]
  }
}

Highcharts.SVGRenderer.prototype.symbols.cross = function (x, y, w, h) {
  return ['M', x + 0.5 * w, y, 'L', x + 0.5 * w, y + h, 'z']
}
if (Highcharts.VMLRenderer) {
  Highcharts.VMLRenderer.prototype.symbols.cross = Highcharts.SVGRenderer.prototype.symbols.cross
}

export default {
  name: 'axleshunt',
  props: {
    assets: { type: Object, required: true },
    railObjectId: { type: [Number, null] },
    sectionData: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      sectionDataProp: this.sectionData,
      chartOptionsEV: chartOptionsEv(this),
      chartOptions: chartOptions(this),
      alarmSettings: null,
      seriesMax: {},
      date: {
        start: moment().subtract(2, 'w').startOf('day'),
        end: moment()
      },
      selectedPeriod: '2weeks',
      isLoading: false,
      selectedPoints: [],
      nextDisabled: true, // defaults last date
      lastPrevSelectedPoint: null,
      sectionOccupations: [],
      severityPerMeasurement: [],
      shuntMessages: [],
      shuntColorPresented: [],
      shuntMessagesPresented: [],
      shuntSeverityPresented: [],
      shuntDateTimePresented: [],
      prevPointClicked: null
    }
  },
  components: {
    'sub-menu': SubMenu,
    'datePicker': DatePicker,
    PeriodSelector
  },
  computed: {
    xMax: {
      get () {
        return Object.keys(this.seriesMax).length ? Object.keys(this.seriesMax).map(k => this.seriesMax[k]).sort((a, b) => a - b).reverse()[0] : 0
      }
    },
    railObjectName () {
      if (this.axleShuntObject) {
        return this.axleShuntObject.Name
      } else {
        return ''
      }
    },
    serieColor () {
      // default color
      return Highcharts.getOptions().colors[0]
    },
    uniqueId () {
      return this.assets.uniqueId || ''
    },
    uniqueIdR8 () {
      return this.assets.uniqueIdR8 || ''
    },
    token () {
      return this.assets.token || ''
    },
    maxDate () {
      return new Date()
    },
    alarmSeries: {
      get () {
        if (!this.alarmSettings || !this.xMax || !this.alarmSettings.shuntCurrentActive) {
          return { warning: null, alarm: null, offset: null }
        }

        return {
          warning: [[0, this.alarmSettings.warningThreshold], [this.xMax, this.alarmSettings.warningThreshold]],
          alarm: [[0, this.alarmSettings.alarmThreshold], [this.xMax, this.alarmSettings.alarmThreshold]],
          offset: [[0, this.alarmSettings.shuntThreshold], [this.xMax, this.alarmSettings.shuntThreshold]]
        }
      }
    },
    colorMap () { // returns an array like [ '#ff0daa', '#9d339a',]
      const colors = rca(maxSelectedPoints + 1, 'hex').splice(1).map(c => `#${c.hex}`) // skip red color
      return [this.serieColor, ...colors]
    }
  },
  watch: {
    sectionDataProp: {
      deep: true,
      handler (val) {
        this.$emit('update:sectionData', val)
      }
    },
    'assets.uniqueIdR8': async function (cur, prev) {
      if (!prev || cur === prev) { return }
      await this.load(true)
    },
    'assets.token': async function (cur) {
      if (!cur) { return }
      await this.load(true)
    },
    isLoading: function (val) {
      this.$emit('loading', val)
    },
    selectedPeriod (period) {
      if (period === 'user_input') {
        return
      }
      const end = moment().startOf('day').format()
      const start = this.getStartDate(end)
      this.date = {
        start,
        end
      }
    }
  },
  async mounted () {
    M.Tabs.init(document.getElementById('tabs'))
    await this.load()
  },
  methods: {
    async load (cleanup = false) {
      if (!this.uniqueIdR8 || !this.token) {
        return this.cleanup()
      }

      try {
        this.isLoading = true
        const dtFrom = moment(this.date.start).startOf('day').format('YYYY-MM-DDTHH:mm:ss')
        const dtTo = moment(this.date.end).endOf('day').format('YYYY-MM-DDTHH:mm:ss')
        const promises = [this.getSectionOccupations(this.uniqueIdR8, this.token, dtFrom, dtTo),
          this.getAlarmSetting(this.uniqueIdR8, this.token),
          this.getAlarmResults(this.uniqueIdR8, this.token, dtFrom, dtTo)]
        await Promise.all(promises)
      } finally {
        this.isLoading = false
        if (cleanup) { this.cleanup() }
        this.updateLastSelectedPoint()
          .refresh()
      }
    },
    cleanup () {
      this.selectedPoints = []
      this.sectionDataProp = []
      this.chartOptionsEV = chartOptionsEv(this)
      this.chartOptions = chartOptions(this)
      this.seriesMax = {}
      return this
    },
    clearSelected () {
      this.selectedPoints.splice(1) // keep 1st point (last item)
      this.seriesMax = {}
      this.refresh()
    },
    refresh () {
      this.updateChartEV()
      this.updateChartOC()
      this.updateAlarmSeries()
      return this
    },
    async getSectionOccupations (uniqueId, token, dtFrom, dtTo) {
      if (!uniqueId || !token || !dtFrom || !dtTo) {
        return
      }
      try {
        this.sectionOccupations = await SectionOccupationsService.getSectionOccupations(uniqueId, token, dtFrom, dtTo)
        return this.sectionOccupations.length
      } finally {}
    },
    async getAlarmResults (uniqueId, token, dtFrom, dtTo) {
      if (!uniqueId || !token || !dtFrom || !dtTo) {
        return
      }
      const sectionAlarms = await SectionAlarmService.getAlarmResults(token, uniqueId, dtFrom, dtTo)
      this.shuntMessages = []
      sectionAlarms.forEach(alarm => {
        this.severityPerMeasurement[alarm.measurementDateTime] = alarm.severity
        this.shuntMessages[alarm.measurementDateTime] = alarm.message
      })
    },
    updateChartEV () {
      const normalMeasurements = []
      const warningMeasurements = []
      const alarmMeasurements = []
      this.sectionOccupations.forEach(occupation => {
        const severity = this.severityPerMeasurement[occupation.measuredDateTime]
        const message = this.shuntMessages[occupation.measuredDateTime]
        const data = this.getDataPoint(occupation, severity)
        switch (severity) {
          case 'Warning':
            warningMeasurements.push(data)
            data.message = message
            break
          case 'Alarm':
            alarmMeasurements.push(data)
            data.message = message
            break
          default:
            normalMeasurements.push(data)
            data.message = null
        }
      })
      this.chartOptionsEV.series[0].data = normalMeasurements
      this.chartOptionsEV.series[1].data = warningMeasurements
      this.chartOptionsEV.series[2].data = alarmMeasurements
    },
    getDataPoint (occupation, severity) {
      let color
      let idx = -1

      if (this.selectedPoints.length) {
        idx = this.selectedPoints.indexOf(occupation.id)
        if (idx >= 0) {
          color = this.colorMap[idx]
        }
      }

      const dataPoint = {
        x: this.$options.filters.epoch(occupation.measuredDateTime),
        y: 1,
        id: occupation.id,
        dt: occupation.measuredDateTime
      }

      switch (severity) {
        case 'Warning':
          dataPoint.marker = {
            fillColor: idx >= 0 ? color : undefined,
            radius: idx >= 0 ? 10 : 6,
            lineColor: colors.warning,
            lineWidth: 2
          }
          break
        case 'Alarm':
          dataPoint.marker = {
            fillColor: color,
            radius: idx >= 0 ? 10 : 6,
            lineColor: colors.alarm,
            lineWidth: 2
          }
          break
        default:
          dataPoint.marker = {
            fillColor: color,
            radius: idx >= 0 ? 8 : 3
          }
          dataPoint.marker.lineColor = colors.ok
      }

      return dataPoint
    },
    updateChartOC () {
      if (!this.sectionOccupations.length) { return }
      this.seriesMax = {}
      if (!this.selectedPoints.length) {
        // api seems to return newest sample at index 0
        this.updateSerie(this.sectionOccupations[0].id)
      } else {
        this.selectedPoints.forEach(p => this.updateSerie(p))
      }
      this.shuntSeverityPresented = []
      this.shuntDateTimePresented = []
      this.shuntMessagesPresented = []
      this.shuntColorPresented = []
      this.selectedPoints.forEach(p => this.updateMessages(p))
      this.setLastSectionData()
    },
    fetchSerie (id) {
      if (!id) { return }
      const sectionOcc = this.sectionOccupations.find(so => so.id === id)
      if (!sectionOcc) { return }

      const max = (sectionOcc.values.length * sectionOcc.samplingInterval).toFixed(2) * 1
      this.seriesMax[id] = max
      this.seriesMax = { ...this.seriesMax } // forces update

      const idx = this.selectedPoints.indexOf(id)
      const color = idx >= 0 ? this.colorMap[idx] : this.colorMap[0]
      const serie = {
        name: moment.utc(sectionOcc.measuredDateTime).local().format('YYYY-MM-DD - HH:mm:ss'),
        id,
        color: color,
        data: sectionOcc.values.map((c, index) => {
          return {
            x: (index * sectionOcc.samplingInterval),
            y: c
          }
        }),
        lineWidth: 3
      }
      return serie
    },
    updateMessages (id) {
      if (!id || !this.selectedPoints.includes(id)) { return false }
      const warn = this.chartOptionsEV.series[1].data.find(s => s.id === id)
      const alarm = this.chartOptionsEV.series[2].data.find(s => s.id === id)
      let color = 'red'
      let idx = -1

      if (this.selectedPoints.length) {
        idx = this.selectedPoints.indexOf(id)
        if (idx >= 0) {
          color = this.colorMap[idx]
        }
      }

      if (warn !== undefined) {
        let utcTimew = moment.utc(warn.dt)
        let localTimew = utcTimew.local()
        var dtw = moment(localTimew).format('YYYY-MM-DD HH:mm:ss')
        this.shuntColorPresented.push(color)
        this.shuntDateTimePresented.push(dtw)
        this.shuntSeverityPresented.push('Warning')
        this.shuntMessagesPresented.push(warn.message)
      }
      if (alarm !== undefined) {
        let utcTime = moment.utc(alarm.dt)
        let localTime = utcTime.local()
        var dta = moment(localTime).format('YYYY-MM-DD HH:mm:ss')
        this.shuntColorPresented.push(color)
        this.shuntDateTimePresented.push(dta)
        this.shuntSeverityPresented.push('Alarm')
        this.shuntMessagesPresented.push(alarm.message)
      }
    },
    updateSerie (id) {
      if (!id) { return }
      const serie = this.chartOptions.series.find(s => s.id === id)
      !serie ? this.addSerie(id) : this.setSerie(id)

      let point = !this.selectedPoints.includes(id) ? id : undefined
      const skip = ['alarm', 'warning', 'offset', ...this.selectedPoints, point].filter(x => x)

      this.chartOptions.series.filter(s => !skip.includes(s.id)).forEach(s => {
        const idx = this.chartOptions.series.findIndex(x => x.id === s.id)
        if (idx < 0) { return }
        this.chartOptions.series.splice(idx, 1) // remove series (except skip)
      })

      this.chartOptions.series.filter(s => this.selectedPoints.includes(s.id)).forEach(s => {
        const idx = this.selectedPoints.indexOf(s.id)
        s.color = idx >= 0 ? this.colorMap[idx] : this.colorMap[0]
      })
    },
    addSerie (id) {
      if (!id) { return }
      const serie = this.fetchSerie(id)
      if (serie) { this.chartOptions.series.push(serie) }
    },
    setSerie (id) {
      if (!id) { return }
      const s = this.fetchSerie(id)
      const serie = this.chartOptions.series.find(s => s.id === id)
      if (!serie || !s) { return }

      serie.name = s.name ? s.name : ''
      serie.data = s.data ? s.data : []
    },
    async getAlarmSetting (uniqueId, token) {
      if (!uniqueId || !token) { return }
      try {
        const resp = await SectionAlarmService.getAlarmSettings(token, uniqueId)
        this.alarmSettings = Object.freeze(resp)
      } catch (err) {
        this.alarmSettings = null
      }
    },
    updateAlarmSeries (series = null) {
      if (!series) { series = this.alarmSeries }
      Object.keys(series).forEach((key, idx) => {
        const serie = this.chartOptions.series.find(s => s.name === key)
        if (serie) {
          serie.data = series[key] ? series[key] : []
        } else {
          const color = key === 'warning' ? colors.warning : colors.alarm
          this.chartOptions.series.push({name: key, data: series[key], color, zIndex: 100})
        }
      })
      return this
    },
    removeChartSeries () {
      this.chartOptionsEV.series[0].data = []
      this.chartOptions.series = []
    },
    switchSelected (id) {
      if (!id) {
        return false
      }
      const selected = this.selectedPoints.includes(id)
      if (!selected) { // Not yet selected
        if (this.selectedPoints.length >= maxSelectedPoints) {
          return false
        }
        this.selectedPoints.push(id)
      } else { // Already selected
        this.removeSelectedPoint(id)
      }
      return true
    },
    removeSelectedPoint (id) {
      if (!id || !this.selectedPoints.includes(id)) { return false }
      let idx = this.selectedPoints.indexOf(id)
      this.selectedPoints.splice(idx, 1)
      delete this.seriesMax[id]
      return true
    },
    resetZoom () {
      const chart = this.$refs.chartEv.chart
      chart.zoom() // resets zoom
      return this
    },
    async prevFrame () {
      this.resetZoom()
      this.nextDisabled = false
      this.date.start = moment(this.date.start).subtract(7, 'd').startOf('day')
      this.date.end = moment(this.date.end).subtract(7, 'd').endOf('day')
      this.selectedPeriod = 'user_input'
      await this.update()
    },
    async lastFrame () {
      this.resetZoom()
      this.nextDisabled = true
      this.date.start = moment().add(-7, 'days')
      this.date.end = moment()
      this.selectedPeriod = 'user_input'
      await this.update()
    },
    async nextFrame () {
      this.resetZoom()
      this.date.start = moment(this.date.start).add(7, 'd').startOf('day')
      this.date.end = moment(this.date.end).add(7, 'd').endOf('day')
      if (this.date.end > moment()) {
        this.nextDisabled = true
        this.date.end = moment()
      }
      this.selectedPeriod = 'user_input'
      await this.update()
    },
    async dateChanged (evt) {
      await this.update()
    },
    async update () {
      try {
        this.isLoading = true
        const dtFrom = moment(this.date.start).startOf('day').format('YYYY-MM-DDTHH:mm:ss')
        const dtTo = moment(this.date.end).endOf('day').format('YYYY-MM-DDTHH:mm:ss')
        const resp = await this.getSectionOccupations(this.uniqueIdR8, this.token, dtFrom, dtTo)
        if (resp) {
          this.refresh()
        } else {
          this.removeChartSeries()
        }
      } finally { this.isLoading = false }
    },
    updateLastSelectedPoint () {
      if (!this.sectionOccupations.length || this.selectedPoints.length) { return this }
      this.selectedPoints = [this.sectionOccupations[0].id]

      return this
    },
    setLastSectionData () {
      const id = this.selectedPoints.length >= 0 ? this.selectedPoints[this.selectedPoints.length - 1] : 0
      const serie = this.chartOptions.series.find(s => s.id === id)
      if (serie) { this.sectionDataProp = serie.data }
      return this
    },
    datePickerChanged () {
      this.selectedPeriod = 'user_input'
    },
    getStartDate (endDate) {
      switch (this.selectedPeriod) {
        case '1week':
          return moment(endDate).subtract(1, 'weeks')
        case '2weeks':
          return moment(endDate).subtract(2, 'weeks')
        case '1month':
          return moment(endDate).subtract(1, 'months')
        case '3months':
          return moment(endDate).subtract(3, 'months')
        case '6months':
          return moment(endDate).subtract(6, 'months')
        case '1year':
          return moment(endDate).subtract(1, 'years')
        default:
          return moment(endDate).subtract(1, 'months')
      }
    }
  }
}
</script>

<style scoped>
.listViewcell{
  padding: 5px;
}
 .buttonbg {
    background: #56CCF2;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
  }
  a.actionLink {
    cursor: pointer
  }
  #chart {
    position: relative;
  }
  .popover-container {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/axleshunt/Events/Index.vue